var React = require('react');

function BannerBorderRev (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M646.63,0C309.25,151.55,0,29.49,0,29.49V115.7H646.63"}));
}

BannerBorderRev.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 646.63 115.7"};

module.exports = BannerBorderRev;

BannerBorderRev.default = BannerBorderRev;
